import { render, staticRenderFns } from "./RedteaGo.vue?vue&type=template&id=7a5813b1"
import script from "./RedteaGo.vue?vue&type=script&lang=js"
export * from "./RedteaGo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports